const routes = [
  {
    path: "/customerServiceApproval", // 客服审批主页面
    name: "customerServiceApproval",
    component: () => import("@src/modules/customerServiceApproval/main"),
    redirect: "/customerServiceApproval/index",
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: "index", // 客服出园审批列表界面
        name: "index",
        component: () =>
          import("@src/modules/customerServiceApproval/view/exitApproval0328"),
        meta: {
          requireAuth: true,
          routerAlive: true,
        },
      },
    ],
  },
];

export default routes;
